import React, { useRef } from 'react';

export type PropertyPhoto = { id: number; url: string; caption?: string };

type Props = {
  photos: PropertyPhoto[];
  pendingPreviews?: { id: string; url: string; file: File }[];
  maxPhotos?: number;
  uploading?: boolean;
  onUpload?: (files: FileList) => void;
  onDelete?: (photoId: number) => void;
  onRemovePending?: (id: string) => void;
  onStageFiles?: (files: FileList) => void;
  hint?: string;
};

export default function PropertyPhotosBlock({
  photos, pendingPreviews = [], maxPhotos = 5, uploading, onUpload, onDelete,
  onRemovePending, onStageFiles, hint,
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const total = photos.length + pendingPreviews.length;
  const canAdd = total < maxPhotos;
  const handleFiles = (files: FileList | null) => {
    if (!files?.length) return;
    if (onStageFiles) onStageFiles(files);
    else if (onUpload) onUpload(files);
  };

  return (
    <div>
      {hint && <p style={{ margin: '0 0 12px', fontSize: 12, color: '#6b7280' }}>{hint}</p>}
      <div className="pp-photos-upload">
        {photos.map(ph => (
          <div key={ph.id} className="pp-photo-card">
            <img src={ph.url} alt="" />
            {onDelete && (
              <button type="button" className="pp-photo-del" onClick={() => onDelete(ph.id)}>×</button>
            )}
          </div>
        ))}
        {pendingPreviews.map(p => (
          <div key={p.id} className="pp-photo-card pp-photo-pending">
            <img src={p.url} alt="" />
            {onRemovePending && (
              <button type="button" className="pp-photo-del" onClick={() => onRemovePending(p.id)}>×</button>
            )}
          </div>
        ))}
        {canAdd && (
          <button type="button" className="pp-photo-add" onClick={() => inputRef.current?.click()} disabled={uploading}>
            <span style={{ fontSize: 20 }}>+</span>
            {uploading ? 'Uploading…' : 'Add photo'}
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple style={{ display: 'none' }}
        onChange={e => { handleFiles(e.target.files); e.target.value = ''; }} />
      <div style={{ marginTop: 8, fontSize: 11, color: '#9ca3af' }}>{total}/{maxPhotos} photos · JPG, PNG, WebP</div>
    </div>
  );
}
